import * as React from 'react';

import {ClassNameBuilder} from '../../utils/ClassNameBuilder';

import * as Styles from './Separator.module.scss';

interface Props {
    className?: string;
}

export const Separator: React.FC<Props> = (props) => {
    const {className} = props;

    const classes = new ClassNameBuilder(Styles, 'separator')
        .add(className)
        .toString();

    return (
        <div className={classes} />
    );
};
